import { SourceDomainRow, Domain } from '../types';

export const mockSourceDomains: SourceDomainRow[] = [
  { id: 'src_1', rank: 1, domain: 'bankrate.com', domain_type: 'Reference', retrievals: 471, retrieved: 47.1, retrieval_rate: 2.0, citation_rate: 2.0 },
  { id: 'src_2', rank: 2, domain: 'nerdwallet.com', domain_type: 'Corporate', retrievals: 313, retrieved: 31.3, retrieval_rate: 2.2, citation_rate: 2.2 },
  { id: 'src_3', rank: 3, domain: 'stockbrokers.com', domain_type: 'Reference', retrievals: 300, retrieved: 30.0, retrieval_rate: 1.3, citation_rate: 1.3 },
  { id: 'src_4', rank: 4, domain: 'cnbc.com', domain_type: 'Editorial', retrievals: 288, retrieved: 28.8, retrieval_rate: 1.6, citation_rate: 1.6 },
  { id: 'src_5', rank: 5, domain: 'reddit.com', domain_type: 'UGC', retrievals: 267, retrieved: 26.7, retrieval_rate: 1.8, citation_rate: 1.8 },
  { id: 'src_6', rank: 6, domain: 'kraken.com', domain_type: 'Corporate', retrievals: 258, retrieved: 25.8, retrieval_rate: 1.8, citation_rate: 1.8 },
  { id: 'src_7', rank: 7, domain: 'youtube.com', domain_type: 'UGC', retrievals: 238, retrieved: 23.8, retrieval_rate: 1.2, citation_rate: 1.2 },
  { id: 'src_8', rank: 8, domain: 'investopedia.com', domain_type: 'Editorial', retrievals: 217, retrieved: 21.7, retrieval_rate: 1.3, citation_rate: 1.3 },
];

export const mockDomainsData: { total: number; page: number; limit: number; data: Domain[] } = {
  total: 25,
  page: 1,
  limit: 20,
  data: [
    {
      id: 'domain_1',
      name: 'tradingbase.com',
      status: 'active',
      added_date: '2024-05-01T00:00:00Z',
      url_count: 245,
      last_crawled: '2024-05-27T10:15:00Z',
      health: 'good'
    },
    {
      id: 'domain_2',
      name: 'blog.tradingbase.com',
      status: 'active',
      added_date: '2024-05-02T00:00:00Z',
      url_count: 187,
      last_crawled: '2024-05-27T09:45:00Z',
      health: 'good'
    },
    {
      id: 'domain_3',
      name: 'docs.tradingbase.com',
      status: 'active',
      added_date: '2024-05-03T00:00:00Z',
      url_count: 432,
      last_crawled: '2024-05-27T10:00:00Z',
      health: 'excellent'
    },
    {
      id: 'domain_4',
      name: 'community.tradingbase.com',
      status: 'active',
      added_date: '2024-05-04T00:00:00Z',
      url_count: 156,
      last_crawled: '2024-05-26T20:30:00Z',
      health: 'good'
    },
    {
      id: 'domain_5',
      name: 'api.tradingbase.com',
      status: 'active',
      added_date: '2024-05-05T00:00:00Z',
      url_count: 223,
      last_crawled: '2024-05-27T08:00:00Z',
      health: 'good'
    }
  ]
};
